import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import "./Navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogoClick = (e) => {
    e.preventDefault();
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
    setMenuOpen(false);
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/");
  };

  const handleSignIn = () => {
    navigate("/sign-in");
  };

  return (
    <nav className="Navbar">
      <div className="Navbar_Content">
        <a href="/" className="Navbar_Logo" onClick={handleLogoClick}>
          <p>KIVORA</p>
          <span className="Navbar_C">©</span>
        </a>

        <div className={`Hamburger ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <ul className={`Navbar_Links ${menuOpen ? "active" : ""}`}>
          <li><a href="#hero" onClick={closeMenu}>Home</a></li>
          <li><a href="#products" onClick={closeMenu}>Shop</a></li>
          <li><a href="#about" onClick={closeMenu}>About</a></li>
          <li><a href="mailto:kivora.co@gmail.com" onClick={closeMenu}>Contact Us</a></li>
          <li>
            {user ? (
              <button className="Navbar_Button" onClick={handleSignOut}>Sign Out</button>
            ) : (
              <button className="Navbar_Button" onClick={handleSignIn}>Sign In</button>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
